import { z } from "zod";
import {
  DocumentMetaTs,
  LocaleTs,
} from "../../common";


import {
  AboutUsNavigationSchema,
  BlogNavigationSchema,
  FaqsNavigationSchema,
  ShopsNavigationSchema,
  TravelersNavigationSchema
} from "../components/header.component";
import { SingleTypes } from "..";
import { useContext } from "react";
import { ContentContext } from "../../content-provider";
import { OmitDocumentMeta } from "@/providers/strapi/client/types";

export type Header = z.output<typeof HeaderTs>;

export const HeaderTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  travelerNavigation: TravelersNavigationSchema,
  shopNavigation: ShopsNavigationSchema,
  aboutUsNavigation: AboutUsNavigationSchema,
  faqsNavigation: FaqsNavigationSchema,
  blogNavigation: BlogNavigationSchema,
  localizations: z.array(DocumentMetaTs),
})

export const HEADER = "header";
export function useHeader<
  K extends keyof Omit<Header, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity?: K,
  // contextKey: string
): Header[K] | Header {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`Header content not found`)
  const header = content[HEADER] as Header;
  if (!header || (entity && !header[entity])) throw new Error(`${entity} content not found`)
  return entity ? header[entity] : header;
}

